export enum PermissionMode {
  Hide,
  View,
  Edit,
}
